import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import jwtDecode from 'jwt-decode';
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { CheckCircle, XCircle } from 'react-feather';
import { SomethingWentWrongView } from '@nsd/fe';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    justifyItems: 'center',
    alignContent: 'center',
    height: '100%',
    width: '100%',
    flexGrow: 1,
    alignItems: 'center'
  }
}));

let captchaToken = '';

const CompleteRegisterView = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const [timeToRedirect, setTimeToRedirect] = React.useState(10);
  const [captchaCollected, setCaptchaCollected] = React.useState(false);
  const [completeRegistrationRunning, setCompanyInfoRunning] = React.useState(
    false
  );
  const [completeRegistrationComplete, setCompanyInfoComplete] = React.useState(
    false
  );
  const [completeRegistrationError, setCompanyInfoError] = React.useState(
    false
  );
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  let data = jwtDecode(token);
  const { t } = useTranslation();

  useEffect(() => {
    if (captchaCollected) {
      setCompanyInfoRunning(true);
      console.log('jwtDecode(token)', jwtDecode(token));

      data = {
        ...data,
        user: {
          ...data.user,
          active: '1'
        },
        captchaToken
      };

      console.log('data', data);
      axios
        .put(`users/${data.userId}`, data, {})
        .then(result => {
          setCompanyInfoRunning(false);
          setCompanyInfoComplete(true);
          console.log('result', result);
        })
        .catch(error => {
          setCompanyInfoRunning(false);
          setCompanyInfoComplete(false);
          setCompanyInfoError(true);
          console.log('error', error);
        });
    }
  }, [captchaCollected]);

  useEffect(() => {
    if (completeRegistrationComplete && timeToRedirect > 0) {
      setTimeout(() => setTimeToRedirect(timeToRedirect - 1), 1000);
    } else if (completeRegistrationComplete && timeToRedirect === 0) {
      setTimeout(() => history.push('/'), 1000);
    }
  }, [completeRegistrationComplete, timeToRedirect]);

  return (
    <div className={classes.root}>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
        useEnterprise
      >
        <GoogleReCaptcha
          onVerify={chg => {
            console.log('GoogleReCaptcha', chg);
            captchaToken = chg;
            setCaptchaCollected(true);
          }}
        />
      </GoogleReCaptchaProvider>
      <div className={classes.root}>
        <Grid
          container
          spacing={4}
          justifyContent={'center'}
          alignContent={'center'}
        >
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {completeRegistrationRunning &&
              !completeRegistrationComplete &&
              !completeRegistrationError && <CircularProgress />}
            {completeRegistrationComplete && (
              <CheckCircle size={48} color={theme.palette.success.main} />
            )}
            {completeRegistrationError && (
              <XCircle size={48} color={theme.palette.error.main} />
            )}
            {completeRegistrationRunning &&
              !completeRegistrationComplete &&
              !completeRegistrationError && (
                <Typography
                  style={{ marginLeft: theme.spacing(3) }}
                  variant="h4"
                  color="textSecondary"
                >
                  {//Registering company account
                  t('completeRegistration.registeringCompanyAccount')}
                </Typography>
              )}
            {!completeRegistrationRunning &&
              completeRegistrationComplete &&
              !completeRegistrationError && (
                <Typography
                  style={{ marginLeft: theme.spacing(3) }}
                  variant="h4"
                  color="textSecondary"
                >
                  {//Registration complete. You will be redirected to the log in page in
                  t('completeRegistration.registrationCompletePart1')}{' '}
                  {timeToRedirect}{' '}
                  {// seconds...
                  t('completeRegistration.registrationCompletePart2')}
                </Typography>
              )}
            {completeRegistrationError && (
              <Typography
                style={{
                  color: theme.palette.error.main,
                  marginLeft: theme.spacing(3)
                }}
                variant="h4"
              >
                Error occurred when registering company account
              </Typography>
            )}
          </Grid>
          {completeRegistrationError && (
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <SomethingWentWrongView />
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};

CompleteRegisterView.propTypes = {};

export default CompleteRegisterView;
